var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { Component, Input, ViewChild } from '@angular/core';
import { FontSizeHelper } from '../helpers/font-size-helper';
import { FontStyleHelper } from '../helpers/font-style-helper';
import { TextAlignHelper } from '../helpers/text-align-helper';
import { FontFamilyHelper } from '../helpers/font-family-help';
var FontSettingComponent = /** @class */ (function (_super) {
    __extends(FontSettingComponent, _super);
    function FontSettingComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.boldEnabled = true;
        _this.fontColorEnabled = true;
        _this.italicEnabled = true;
        _this.underLineEnabled = true;
        _this.textAlignHelper = new TextAlignHelper();
        _this.fontFamilies = FontFamilyHelper.getFontFamilies();
        _this.FontFamilyEnabled = true;
        _this.fontSizes = FontSizeHelper.getFontSizes();
        _this.validateFontSize = function (currentFormControl) {
            return FontStyleHelper.fontSizeValidate(currentFormControl.value);
        };
        return _this;
    }
    Object.defineProperty(FontSettingComponent.prototype, "fontSize", {
        get: function () {
            return FontStyleHelper.dropPx(this.font.fontSize);
        },
        set: function (value) {
            this.font.fontSize = FontStyleHelper.addPx(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontSettingComponent.prototype, "isBold", {
        get: function () {
            return this.font.isBold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontSettingComponent.prototype, "textAlign", {
        get: function () {
            return this.font.textAlign;
        },
        set: function (value) {
            this.font.textAlign = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontSettingComponent.prototype, "fontColor", {
        get: function () {
            return this.font.color;
        },
        set: function (value) {
            this.font.color = value;
            $('.evo-pointer').css('background', 'none');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontSettingComponent.prototype, "alignLeft", {
        get: function () {
            return TextAlignHelper.isAlignLeft(this.textAlign);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontSettingComponent.prototype, "alignCenter", {
        get: function () {
            return TextAlignHelper.isAlignCenter(this.textAlign);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontSettingComponent.prototype, "alignRight", {
        get: function () {
            return TextAlignHelper.isAlignRight(this.textAlign);
        },
        enumerable: true,
        configurable: true
    });
    FontSettingComponent.prototype.ngOnInit = function () {
        $('.evo-pointer').css('background', 'none');
        this.fontFamily = this.font.fontFamily;
    };
    FontSettingComponent.prototype.setBold = function () {
        this.font.isBold = !this.font.isBold;
    };
    FontSettingComponent.prototype.setItalic = function () {
        this.font.isItalic = !this.font.isItalic;
    };
    FontSettingComponent.prototype.setUnderline = function () {
        this.font.isUnderline = !this.font.isUnderline;
    };
    FontSettingComponent.prototype.setAlignLeft = function () {
        this.font.textAlign = TextAlignHelper.AlignLeft;
    };
    FontSettingComponent.prototype.setAlignCenter = function () {
        this.font.textAlign = TextAlignHelper.AlignCenter;
    };
    FontSettingComponent.prototype.setAlignRight = function () {
        this.font.textAlign = TextAlignHelper.AlignRight;
    };
    FontSettingComponent.prototype.onFontFamilyChanged = function () {
        this.font.fontFamily = this.fontFamily;
    };
    FontSettingComponent.prototype.onFontSizeChanged = function (args) {
        var fontSizeValue = FontStyleHelper.dropPx(args.value);
        if (fontSizeValue > 1000) {
            this.fontSize = 1000;
        }
        else if (fontSizeValue <= 0 || isNaN(fontSizeValue)) {
            this.fontSize = null;
        }
        FontStyleHelper.updateDropdownDisplayValue(this.fontSize, this.fontSizeDropdown);
        if (this.fontSize != null) {
            this.font.fontSize = FontStyleHelper.addPx(this.fontSize);
        }
    };
    FontSettingComponent.prototype.onFontSizeKeyDown = function (event) {
        FontStyleHelper.limitInputIsNumber(event);
    };
    FontSettingComponent.prototype.setFontColor = function (color) {
        this.fontColor = color;
    };
    __decorate([
        Input()
    ], FontSettingComponent.prototype, "font", void 0);
    __decorate([
        Input()
    ], FontSettingComponent.prototype, "textAlignEnabled", void 0);
    __decorate([
        Input()
    ], FontSettingComponent.prototype, "boldEnabled", void 0);
    __decorate([
        Input()
    ], FontSettingComponent.prototype, "fontColorEnabled", void 0);
    __decorate([
        Input()
    ], FontSettingComponent.prototype, "italicEnabled", void 0);
    __decorate([
        Input()
    ], FontSettingComponent.prototype, "underLineEnabled", void 0);
    __decorate([
        Input()
    ], FontSettingComponent.prototype, "FontFamilyEnabled", void 0);
    __decorate([
        ViewChild('FontSizeDropdown', { static: false })
    ], FontSettingComponent.prototype, "fontSizeDropdown", void 0);
    FontSettingComponent = __decorate([
        Component({
            selector: 'font-setting',
            template: "<div class=\"design-font-setting\"> <div class=\"textToolBar\"> <div class=\"font-family\" *ngIf='FontFamilyEnabled'> <p-dropdown #FontFamilyDropdown class=\"fontFamily\" name=\"fontFamily\" [options]=\"fontFamilies\" [(ngModel)]=\"fontFamily\" [style]=\"{'width':'100px', 'min-width': '100px'}\" (onChange)=\"onFontFamilyChanged()\"> <ng-template let-item pTemplate=\"selectedItem\"> <span>{{lc(item.label)}}</span> </ng-template> <ng-template let-font pTemplate=\"item\"> <span>{{lc(font.label)}}</span> </ng-template> </p-dropdown> </div> <p-dropdown #FontSizeDropdown name=\"fontSize\" [options]=\"fontSizes\" [(ngModel)]=\"fontSize\" [style]=\"{'width':'80px'}\" editable=\"true\" (onChange)=\"onFontSizeChanged($event)\" (keydown)=\"onFontSizeKeyDown($event)\" [custom-func-validate]=\"validateFontSize\"></p-dropdown> <span *ngIf=\"boldEnabled\"> <a class=\"bold\" [class.clicked]=\"isBold\" (click)=\"setBold()\"></a> </span> <span *ngIf=\"italicEnabled\"> <a class=\"italic\" [class.clicked]=\"font.isItalic\" (click)=\"setItalic()\"></a> </span> <span *ngIf=\"underLineEnabled\"> <a class=\"underline\" [class.clicked]=\"font.isUnderline\" (click)=\"setUnderline()\"></a> </span> <span *ngIf=\"textAlignEnabled\"> <a class=\"alignLeft\" [class.clicked]=\"alignLeft\" (click)=\"setAlignLeft()\"></a> </span> <span *ngIf=\"textAlignEnabled\"> <a class=\"alignCenter\" [class.clicked]=\"alignCenter\" (click)=\"setAlignCenter()\"></a> </span> <span *ngIf=\"textAlignEnabled\"> <a class=\"alignRight\" [class.clicked]=\"alignRight\" (click)=\"setAlignRight()\"></a> </span> <span *ngIf=\"fontColorEnabled\"> <a class=\"fontColor\"> <font-color-picker [color]=\"fontColor\" (sentColor)=\"setFontColor($event)\"></font-color-picker> </a> </span> </div> </div>",
            styles: [".design-font-setting { .form-control { background-color: white; } .textToolBar { display: inline-flex; select { float: left; width: 80px; height: 32px; padding: 0; } a { text-decoration: none; display: inline-block; height: 20px; cursor: pointer; width: 20px; vertical-align: -webkit-baseline-middle; background-image: url(\"/assets/common/images/configure/textToolBar.png\"); } ::ng-deep .ui-inputtext { padding-top: 5px; padding-bottom: 6px; } .font-family { margin-right: 10px; } } .textToolBar>span { float: left; padding: 0 2px; line-height: 24px; } .textToolBar>span:last-child { position: relative; } .bold { background-position: -40px 0px; } .bold.clicked { background-position: 0px 0px; } .italic { background-position: 80px 20px; } .italic.clicked { background-position: 120px 20px; } .underline { background-position: 140px 0px; } .underline.clicked { background-position: 180px 0px; } .alignLeft { background-position: 80px 0px; } .alignLeft.clicked { background-position: 120px 0px; } .alignCenter { background-position: 20px 0px; } .alignCenter.clicked { background-position: 60px 0px; } .alignRight { background-position: 200px 20px; } .alignRight.clicked { background-position: 240px 20px; } .fontColor { background-position: 140px 20px; } .fontColor.clicked { background-position: 180px 20px; } .colorPicker { position: absolute; right: 5px; bottom: 6px; width: 13px; height: 2px; border: none; } .noResize { resize: none; } .form-control.fc-Form.font-size-select { width: 140px; } }"]
        })
    ], FontSettingComponent);
    return FontSettingComponent;
}(ConfigureComponentBase));
export { FontSettingComponent };
